// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__w1F9d","content":"styles_content__2rXk_"};